var _clipPath, _clipPath2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 9 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l4.5 3L0 6",
    id: "b"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9v6H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v6h9V0z",
    fill: "#001489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v3h9V0z",
    fill: "#e03c31"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l4.5 3L0 6m4.5-3H9",
    id: "d"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    stroke: "#ffb81c",
    clipPath: "url(#c)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "none",
    stroke: "#007749",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.ae8f01fe7acf97aba96fbde7eb67cb91.svg";
export { ForwardRef as ReactComponent };